<phx-select
  *ngIf="!isMobile; else mobileSelect"
  ngModel
  [phxSearchPlaceholder]="phxPlaceholder"
  [phxOptions]="phxOptions"
  [phxShowSearch]="true"
  [phxServerSearch]="true"
  [phxShowSubText]="true"
  [phxHighlightSubtext]="true"
  [phxDropdownWidth]="360"
  [phxDropdownHeight]="700"
  [phxPlacement]="'cover'"
  [phxDropdownClassName]="'debug-overlay'"
  [phxSearchDebounceTime]="phxDebounceTime"
  [phxTriggerTemplate]="triggerTemplate"
  [phxFooterRightTemplate]="phxShowGroupByToggle ? footerRightTemplate : null"
  [phxResultNotFound]="noDataMessageTemplate"
  [phxLoading]="phxLoading"
  [phxSearchText]="phxInputValue"
  [phxPreventSelection]="true"
  [phxOptimisticSelection]="true"
  [phxDropdownOffset]="dropdownOffset"
  (ngModelChange)="onItemClick($event)"
  (phxSearchChange)="onSearch($event)"
  (phxOpenChange)="onOpenChange($event)"
></phx-select>

<ng-template #mobileSelect>
  <ng-container *ngTemplateOutlet="triggerTemplate"></ng-container>
  <phx-mobile-select
    ngModel
    [(phxOpen)]="isOpen"
    (phxOpenChange)="onOpenChange($event)"
    [phxSearchPlaceholder]="phxPlaceholder"
    [phxOptions]="phxOptions"
    phxHeaderTitle="Search"
    [phxServerSearch]="true"
    [phxShowSubText]="true"
    [phxHighlightSubtext]="true"
    [phxDropdownWidth]="360"
    [phxSearchDebounceTime]="phxDebounceTime"
    [phxTriggerTemplate]="triggerTemplate"
    [phxFooterRightTemplate]="phxShowGroupByToggle ? footerRightTemplate : null"
    [phxResultNotFound]="noDataMessageTemplate"
    [phxLoading]="phxLoading"
    [phxSearchText]="phxInputValue"
    [phxPreventSelection]="true"
    [phxOptimisticSelection]="true"
    (ngModelChange)="onItemClick($event)"
    (phxSearchChange)="onSearch($event)"
  ></phx-mobile-select>
</ng-template>

<ng-template #triggerTemplate>
  <div
    [attr.tabIndex]="isMobile ? 0 : null"
    class="phx-omnisearch-trigger"
    [class.phx-omnisearch-trigger-secondary]="phxSecondaryTrigger"
    [class.phx-omnisearch-trigger-collapsed]="phxTriggerCollapsed"
    (click)="onTriggerClick()"
  >
    <i phx-icon [phxIcon]="MagnifyingGlassIcon" color="currentColor"></i>
    <span *ngIf="!phxTriggerCollapsed">{{ "Search" | phxTranslate }}</span>
  </div>
</ng-template>

<ng-template #footerRightTemplate>
  <div class="phx-omnisearch-type-toggler">
    <span class="phx-omnisearch-type-toggler-text phx-web-type-small">
      {{ "Group results" | phxTranslate }}
    </span>
    <phx-toggle
      [phxSwitch]="true"
      phxSize="small"
      [(ngModel)]="phxShowByType"
      (ngModelChange)="onToggleChange($event)"
      phxOmnifilterFocusableDirective="toggle"
      tabindex="-1"
    ></phx-toggle>
  </div>
</ng-template>

<ng-template #noDataMessageTemplate>
  <div class="phx-omnisearch-no-results">
    <span *ngIf="isSearched" class="phx-omnisearch-no-results-title">{{ "No matches found" | phxTranslate }}</span>
    <span class="phx-omnisearch-no-results-message">{{ isSearched ? noResultsMessage : findByString }}</span>
  </div>
</ng-template>
